<template>
  <div id="contenedor-agregar-nuevo-presupuestoModificado-modificacion">
    <v-form ref="registrarNuevoPresupuestoModificacion" v-model="formularioValido">
      <v-card>
        <v-card-title>
          Registrar Nueva Modificación
          <v-spacer></v-spacer>
          <v-btn
            icon
            @click="cerrar">
            <v-icon class="secondary--text" large>highlight_off</v-icon>
          </v-btn>
        </v-card-title>
        <v-row>
          <custom-select
            cols="12" md="3"
            v-model="presupuestoModificado.tipo"
            label="Tipo*"
            :items="tipos"
            :rules="[mixReglas.requerido]"
            required>
          </custom-select>
          <custom-date-picker
            cols="12" md="3"
            v-model="presupuestoModificado.fecha"
            label="Fecha*"
            :rules="[mixReglas.requerido]">
          </custom-date-picker>
          <custom-text-field
            cols="12" md="3"
            v-model="presupuestoModificado.numero"
            label="Número">
          </custom-text-field>
          <custom-text-field-green
            cols="12" md="3"
            v-model.number="presupuestoModificado.importe"
            label="Modificado"
            prefix="$"
            :value="0"
            :rules="[mixReglas.requerido]"
            type="number">
          </custom-text-field-green>
          <custom-text-area
            cols="12"
            v-model="presupuestoModificado.justificacion"
            label="Justificacion">
          </custom-text-area>
        </v-row>
        <v-divider class="bkground" />
        <v-card-actions>
          <v-spacer></v-spacer>
          <custom-button
            @click="cerrar"
            tipo="formCancelar"
            label="Cancelar"
            class="mr-3">
          </custom-button>
          <custom-button
            @click="mixAgregarPresupuestoModificado"
            :disabled="!formularioValido || enviandoFormulario"
            tipo="formAceptar"
            label="Guardar">
          </custom-button>
        </v-card-actions>
      </v-card>
    </v-form>
  </div>
</template>

<script>
import CustomTextField from '@/components/inputs/TextField.vue';
import CustomTextFieldGreen from '@/components/inputs/TextFieldGreen.vue';
import CustomSelect from '@/components/inputs/Select.vue';
import CustomTextArea from '@/components/inputs/TextArea.vue';
import CustomDatePicker from '@/components/inputs/DatePicker.vue';
import CustomButton from '@/components/buttons/Button.vue';
import mixPresupuestosModificaciones from './mixPresupuestosModificaciones';

export default {
  name: 'NuevoPresupuestoModificacion',
  mixins: [mixPresupuestosModificaciones],
  components: {
    CustomTextField,
    CustomTextFieldGreen,
    CustomSelect,
    CustomTextArea,
    CustomDatePicker,
    CustomButton,
  },
  props: {
    presupuestoDetalleId: String,
    presupuestoId: String,
  },
  data() {
    return {
      formularioValido: false,
      enviandoFormulario: false,
      presupuestoModificado: {
        idPresupuestoDetalle: '', // ID!,
        tipo: 'AMPLIACIÓN', // String!,
        fecha: null, // Date!,
        numero: null, // String,
        justificacion: null, // String,
        importe: '', // Float!,
      },
      tipos: [
        'AMPLIACIÓN',
        'REDUCCIÓN',
      ],
    };
  },
  mounted() {
    this.presupuestoModificado.idPresupuestoDetalle = this.presupuestoDetalleId;
  },
  methods: {
    cerrar() {
      this.limpiarFormulario();
      this.$emit('cerrar');
    },
    limpiarFormulario() {
      this.$refs.registrarNuevoPresupuestoModificacion.reset();
    },
  },
  computed: {},
};
</script>
